/**
 * ═══════════════════════════════════════════════════════════════
 * ECS CART SELECTOR + DIFUSOR SWAP — v15c
 * ═══════════════════════════════════════════════════════════════
 */

(function () {

  var CONFIG = {
    NOVA_HANDLE:        'difusornova',
    STELLA_HANDLE:      'difusor-stella',
    NOVA_SUB_HANDLE:    'difusor-nova-suscripcion',
    STELLA_SUB_HANDLE:  'difusor-stella-suscripcion',
    NOVA_OTP_HANDLE:    'difusor-nova-esenciaotp',
    STELLA_OTP_HANDLE:  'difusor-stella-esenciaotp',
    NOVA_SUB_VARIANT:   51865206456605,
    STELLA_SUB_VARIANT: 51865213567261,
    NOVA_OTP_VARIANT:   51865237782813,
    STELLA_OTP_VARIANT: 51865239781661
  };

  var HANDLES_ESPECIALES = [
    CONFIG.NOVA_SUB_HANDLE,
    CONFIG.STELLA_SUB_HANDLE,
    CONFIG.NOVA_OTP_HANDLE,
    CONFIG.STELLA_OTP_HANDLE
  ];

  var productCache = {};

  // CSS inyectado — oculta botones +/− en difusores especiales
  (function inyectarCSSEspeciales() {
    if (document.getElementById('ecs-especiales-css')) return;
    var style = document.createElement('style');
    style.id = 'ecs-especiales-css';
    style.textContent = [
      '[data-ecs-especial="true"] .rebuy-quantity,',
      '[data-ecs-especial="true"] [class*="quantity-wrapper"],',
      '[data-ecs-especial="true"] .rebuy-cart__flyout-item-quantity,',
      '[data-ecs-especial="true"] button[aria-label*="ncrease"],',
      '[data-ecs-especial="true"] button[aria-label*="ecrease"],',
      '[data-ecs-especial="true"] input[type="number"] {',
      '  display: none !important;',
      '  pointer-events: none !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  })();

  function formatPrice(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' MXN';
  }

  function getProductData(handle) {
    return new Promise(function (resolve, reject) {
      if (productCache[handle]) { resolve(productCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) { productCache[handle] = data; resolve(data); })
        .catch(reject);
    });
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // ─────────────────────────────────────────────────────────────
  // MARCAR DIFUSORES ESPECIALES EN EL DOM
  // ─────────────────────────────────────────────────────────────

  function marcarDifusoresEspeciales(cart) {
    if (!cart.items || cart.items.length === 0) return;

    var domItems = document.querySelectorAll('.rebuy-cart__flyout-item, .rebuy-cart-item');
    domItems.forEach(function (el) { el.removeAttribute('data-ecs-especial'); });

    var domItemsFiltrados = [];
    domItems.forEach(function (el) {
      var tieneContenido = el.querySelector('img, [class*="item-title"], [class*="product-title"], .rebuy-cart__flyout-item-title');
      if (tieneContenido) domItemsFiltrados.push(el);
    });

    cart.items.forEach(function (item, index) {
      var h = item.handle || '';
      var itemEl = domItemsFiltrados[index];
      if (!itemEl) return;

      if (HANDLES_ESPECIALES.indexOf(h) > -1) {
        itemEl.setAttribute('data-ecs-especial', 'true');
        var botones = itemEl.querySelectorAll('button');
        botones.forEach(function (btn) {
          var label = (btn.getAttribute('aria-label') || '').toLowerCase();
          var texto = btn.textContent.trim();
          var esmas   = texto === '+' || label.indexOf('increase') > -1 || label.indexOf('add') > -1;
          var esmenos = texto === '−' || texto === '-' || label.indexOf('decrease') > -1 || label.indexOf('remove') > -1;
          if ((esmas || esmenos) && !btn.closest('[class*="remove"]')) {
            btn.style.setProperty('display', 'none', 'important');
            btn.setAttribute('disabled', 'disabled');
          }
        });
        var inputs = itemEl.querySelectorAll('input[type="number"]');
        inputs.forEach(function (inp) {
          inp.style.setProperty('pointer-events', 'none', 'important');
          inp.setAttribute('readonly', 'readonly');
        });
      } else {
        itemEl.removeAttribute('data-ecs-especial');
      }
    });
  }

  function ocultarCantidadDifusoresEspeciales() {
    setTimeout(function () {
      getCart().then(function (cart) { marcarDifusoresEspeciales(cart); });
    }, 150);
  }

  // ─────────────────────────────────────────────────────────────
  // BLOQUEO DE CHECKOUT
  // ─────────────────────────────────────────────────────────────

  var checkoutBloqueado = false;

  function interceptarCheckout() {
    document.addEventListener('click', function (e) {
      if (!checkoutBloqueado) return;
      var esCheckout = false;
      var el = e.target;
      while (el && el !== document.body) {
        if (el.classList) {
          if (el.classList.contains('rebuy-cart__checkout-button') ||
              el.getAttribute('name') === 'checkout' ||
              (el.className && el.className.indexOf('checkout') > -1)) {
            esCheckout = true; break;
          }
        }
        el = el.parentElement;
      }
      if (esCheckout) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var btn = e.target.closest ? e.target.closest('[class*="checkout"]') : e.target;
        if (btn) {
          var textoActual = btn.textContent;
          btn.textContent = 'Espera, actualizando…';
          setTimeout(function () { btn.textContent = textoActual; }, 1200);
        }
      }
    }, true);
  }

  function bloquearCheckout(bloquear) {
    checkoutBloqueado = bloquear;
    var selectores = [
      '.rebuy-cart__checkout-button',
      '[class*="checkout-button"]',
      '[class*="checkout_button"]',
      'button[name="checkout"]'
    ].join(', ');
    var btns = document.querySelectorAll(selectores);
    btns.forEach(function (btn) {
      if (bloquear) {
        btn.setAttribute('disabled', 'disabled');
        btn.style.opacity       = '0.45';
        btn.style.cursor        = 'not-allowed';
        btn.style.pointerEvents = 'none';
        if (!btn.getAttribute('data-ecs-original-text')) {
          btn.setAttribute('data-ecs-original-text', btn.textContent.trim());
        }
        btn.textContent = 'Actualizando precio…';
      } else {
        btn.removeAttribute('disabled');
        btn.style.opacity       = '';
        btn.style.cursor        = '';
        btn.style.pointerEvents = '';
        var textoOriginal = btn.getAttribute('data-ecs-original-text');
        if (textoOriginal) {
          btn.textContent = textoOriginal;
          btn.removeAttribute('data-ecs-original-text');
        }
      }
    });
  }

  // ─────────────────────────────────────────────────────────────
  // VALIDACIÓN DE UNIDADES
  // ─────────────────────────────────────────────────────────────

  function verificarUnidades(cart) {
    var avisoAnterior = document.querySelector('.ecs-aviso-unidades');
    if (avisoAnterior) avisoAnterior.remove();
    if (!cart.items || cart.items.length === 0) return;

    var cantidadDifusores = 0;
    var cantidadEsencias  = 0;

    cart.items.forEach(function (item) {
      var h = item.handle || '';
      if (HANDLES_ESPECIALES.indexOf(h) > -1) cantidadDifusores += item.quantity;
      if (h.indexOf('esencia') > -1 &&
          h !== CONFIG.NOVA_OTP_HANDLE &&
          h !== CONFIG.STELLA_OTP_HANDLE) {
        cantidadEsencias += item.quantity;
      }
    });

    if (cantidadDifusores === 0) return;
    if (cantidadDifusores !== cantidadEsencias) {
      var footer = document.querySelector('.rebuy-cart__flyout-footer') ||
                   document.querySelector('.rebuy-cart__footer');
      if (!footer) return;
      var aviso = document.createElement('div');
      aviso.className = 'ecs-aviso-unidades';
      aviso.style.cssText = [
        'background:#2D1A0E','border:1px solid #C9A96E','border-radius:6px',
        'color:#F7F4EF','font-family:Jost,sans-serif','font-size:12px',
        'letter-spacing:0.05em','line-height:1.5','margin:8px 12px',
        'padding:10px 14px','text-align:center'
      ].join(';');
      aviso.innerHTML =
        '<strong style="color:#C9A96E;display:block;margin-bottom:4px">' +
        '⚠️ Descuento por par difusor + esencia</strong>' +
        'El descuento aplica cuando cada difusor tiene su esencia. ' +
        'Tienes ' + cantidadDifusores + ' difusor' + (cantidadDifusores > 1 ? 'es' : '') +
        ' y ' + cantidadEsencias + ' esencia' + (cantidadEsencias !== 1 ? 's' : '') + '.';
      footer.parentNode.insertBefore(aviso, footer);
    }
  }

  // ─────────────────────────────────────────────────────────────
  // SWAP DE DIFUSOR
  // ─────────────────────────────────────────────────────────────

  var swapEnProceso = false;

  function ejecutarSwap() {
    if (swapEnProceso) return;

    getCart().then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;

      verificarUnidades(cart);
      marcarDifusoresEspeciales(cart);

      var novasOriginales   = [];
      var stellasOriginales = [];
      var novasEspeciales   = [];
      var stellasEspeciales = [];
      var cantEsenciasSub   = 0;
      var cantEsenciasOtp   = 0;

      cart.items.forEach(function (item) {
        var h = item.handle || '';
        if (h === CONFIG.NOVA_HANDLE)   novasOriginales.push(item);
        if (h === CONFIG.NOVA_SUB_HANDLE || h === CONFIG.NOVA_OTP_HANDLE) novasEspeciales.push(item);
        if (h === CONFIG.STELLA_HANDLE) stellasOriginales.push(item);
        if (h === CONFIG.STELLA_SUB_HANDLE || h === CONFIG.STELLA_OTP_HANDLE) stellasEspeciales.push(item);
        if (h.indexOf('esencia') > -1 && h !== CONFIG.NOVA_OTP_HANDLE && h !== CONFIG.STELLA_OTP_HANDLE) {
          if (item.selling_plan_allocation) { cantEsenciasSub += item.quantity; }
          else { cantEsenciasOtp += item.quantity; }
        }
      });

      var subDisponibles = cantEsenciasSub;
      var otpDisponibles = cantEsenciasOtp;
      var swapsNecesarios = [];

      novasEspeciales.forEach(function (item) {
        var targetHandle, targetVariant;
        if (subDisponibles > 0) { targetHandle = CONFIG.NOVA_SUB_HANDLE; targetVariant = CONFIG.NOVA_SUB_VARIANT; subDisponibles -= 1; }
        else if (otpDisponibles > 0) { targetHandle = CONFIG.NOVA_OTP_HANDLE; targetVariant = CONFIG.NOVA_OTP_VARIANT; otpDisponibles -= 1; }
        else { targetHandle = CONFIG.NOVA_HANDLE; targetVariant = null; }
        if (item.handle !== targetHandle) {
          swapsNecesarios.push({ itemHandle: item.handle, itemKey: item.key, itemQuantity: item.quantity,
            variantObjetivo: targetVariant, handleObjetivo: targetVariant ? null : CONFIG.NOVA_HANDLE, _variantResuelto: null });
        }
      });

      stellasEspeciales.forEach(function (item) {
        var targetHandle, targetVariant;
        if (subDisponibles > 0) { targetHandle = CONFIG.STELLA_SUB_HANDLE; targetVariant = CONFIG.STELLA_SUB_VARIANT; subDisponibles -= 1; }
        else if (otpDisponibles > 0) { targetHandle = CONFIG.STELLA_OTP_HANDLE; targetVariant = CONFIG.STELLA_OTP_VARIANT; otpDisponibles -= 1; }
        else { targetHandle = CONFIG.STELLA_HANDLE; targetVariant = null; }
        if (item.handle !== targetHandle) {
          swapsNecesarios.push({ itemHandle: item.handle, itemKey: item.key, itemQuantity: item.quantity,
            variantObjetivo: targetVariant, handleObjetivo: targetVariant ? null : CONFIG.STELLA_HANDLE, _variantResuelto: null });
        }
      });

      novasOriginales.forEach(function (item) {
        var targetVariant = null;
        if (subDisponibles > 0) { targetVariant = CONFIG.NOVA_SUB_VARIANT; subDisponibles -= 1; }
        else if (otpDisponibles > 0) { targetVariant = CONFIG.NOVA_OTP_VARIANT; otpDisponibles -= 1; }
        if (targetVariant !== null) {
          swapsNecesarios.push({ itemHandle: item.handle, itemKey: item.key, itemQuantity: item.quantity,
            variantObjetivo: targetVariant, handleObjetivo: null, _variantResuelto: null });
        }
      });

      stellasOriginales.forEach(function (item) {
        var targetVariant = null;
        if (subDisponibles > 0) { targetVariant = CONFIG.STELLA_SUB_VARIANT; subDisponibles -= 1; }
        else if (otpDisponibles > 0) { targetVariant = CONFIG.STELLA_OTP_VARIANT; otpDisponibles -= 1; }
        if (targetVariant !== null) {
          swapsNecesarios.push({ itemHandle: item.handle, itemKey: item.key, itemQuantity: item.quantity,
            variantObjetivo: targetVariant, handleObjetivo: null, _variantResuelto: null });
        }
      });

      if (swapsNecesarios.length === 0) return;

      swapEnProceso = true;
      bloquearCheckout(true);

      function ejecutarSiguiente(index) {
        if (index >= swapsNecesarios.length) {
          swapEnProceso = false;
          bloquearCheckout(false);
          document.dispatchEvent(new CustomEvent('rebuy:cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        var swap = swapsNecesarios[index];
        var promesa;

        if (swap.variantObjetivo) {
          swap._variantResuelto = swap.variantObjetivo;
          promesa = Promise.resolve();
        } else {
          promesa = getProductData(swap.handleObjetivo).then(function (data) {
            swap._variantResuelto = data.variants[0].id;
          });
        }

        promesa
          .then(function () { return getCart(); })
          .then(function (cartFresco) {
            var itemFresco = null;
            cartFresco.items.forEach(function (it) {
              if (it.key === swap.itemKey) itemFresco = it;
            });
            if (!itemFresco) {
              var keysYaProcesadas = swapsNecesarios.slice(0, index)
                .map(function (s) { return s._keyFresca; }).filter(Boolean);
              cartFresco.items.forEach(function (it) {
                if (it.handle === swap.itemHandle && !itemFresco &&
                    keysYaProcesadas.indexOf(it.key) === -1) itemFresco = it;
              });
            }
            if (!itemFresco) { ejecutarSiguiente(index + 1); return Promise.resolve('skip'); }
            swap._keyFresca      = itemFresco.key;
            swap._quantityFresca = itemFresco.quantity;
            return Promise.resolve('ok');
          })
          .then(function (estado) {
            if (estado === 'skip') return Promise.resolve();
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: swap._keyFresca, quantity: 0 })
            });
          })
          .then(function () {
            if (!swap._keyFresca) return;
            return fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: swap._variantResuelto, quantity: swap._quantityFresca || swap.itemQuantity })
            });
          })
          .then(function () { ejecutarSiguiente(index + 1); })
          .catch(function (err) {
            console.error('[ECS Swap v15c] Error en swap ' + index + ':', err);
            swapEnProceso = false; bloquearCheckout(false);
          });
      }

      ejecutarSiguiente(0);
    });
  }

  // ─────────────────────────────────────────────────────────────
  // SELECTOR DE ESENCIAS
  // ─────────────────────────────────────────────────────────────

  function changeCartItem(lineIndex, variantId, quantity, sellingPlanId) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    })
    .then(function () {
      var body = { id: variantId, quantity: quantity };
      if (sellingPlanId) body.selling_plan = sellingPlanId;
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
    })
    .then(function () {
      setTimeout(ejecutarSwap, 400);
      document.dispatchEvent(new CustomEvent('rebuy:cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  function buildSelector(cartItem, productData, lineIndex) {
    var currentVariantId = cartItem.variant_id;
    var currentSellingPlanId = cartItem.selling_plan_allocation
      ? cartItem.selling_plan_allocation.selling_plan.id : null;
    var currentVariant = productData.variants.find(function (v) { return v.id === currentVariantId; });
    if (!currentVariant) return null;

    var state = { variantId: currentVariantId, sellingPlanId: currentSellingPlanId, quantity: cartItem.quantity };
    var wrapper = document.createElement('div');
    wrapper.className = 'ecs-selector';

    function updatePriceDisplay() {
      var priceEl = wrapper.querySelector('.ecs-selector__price');
      if (!priceEl) return;
      var variant = productData.variants.find(function (v) { return v.id === state.variantId; });
      if (!variant) return;
      if (state.sellingPlanId) {
        var alloc = (variant.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id === state.sellingPlanId; });
        if (alloc) {
          priceEl.innerHTML = '<span class="ecs-selector__price-sale">' + formatPrice(alloc.price) + '</span>' +
            '<span class="ecs-selector__price-compare">' + formatPrice(variant.price) + '</span>';
          return;
        }
      }
      priceEl.innerHTML = '<span class="ecs-selector__price-regular">' + formatPrice(variant.price) + '</span>';
    }

    function renderFrequencyPills() {
      var freqContainer = wrapper.querySelector('.ecs-selector__frequency');
      if (!freqContainer) return;
      var variant = productData.variants.find(function (v) { return v.id === state.variantId; });
      var plans = variant ? (variant.selling_plan_allocations || []) : [];
      if (plans.length === 0) { freqContainer.style.display = 'none'; state.sellingPlanId = null; updatePriceDisplay(); return; }
      freqContainer.style.display = '';
      var grupoActivo = null;
      (productData.selling_plan_groups || []).forEach(function (group) {
        if (group.name && group.name.indexOf(variant.title) > -1) grupoActivo = group;
      });
      if (!grupoActivo && productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
        grupoActivo = productData.selling_plan_groups[0];
      }
      var planIdsActivos = {};
      if (grupoActivo) { (grupoActivo.selling_plans || []).forEach(function (plan) { planIdsActivos[plan.id] = plan.name; }); }
      var planesFiltrados = plans.filter(function (alloc) { return planIdsActivos[alloc.selling_plan_id] !== undefined; });
      var html = '<p class="ecs-selector__label">Frecuencia</p><div class="ecs-selector__pills">';
      html += '<button class="ecs-selector__pill ' + (!state.sellingPlanId ? 'ecs-selector__pill--active' : '') + '" data-plan-id="">Una vez</button>';
      planesFiltrados.forEach(function (alloc) {
        var planName = planIdsActivos[alloc.selling_plan_id] || 'Suscripción';
        var isActive = state.sellingPlanId === alloc.selling_plan_id ? 'ecs-selector__pill--active' : '';
        var discount = (alloc.price < variant.price) ? ' <small>-' + formatPrice(variant.price - alloc.price) + '</small>' : '';
        html += '<button class="ecs-selector__pill ' + isActive + '" data-plan-id="' + alloc.selling_plan_id + '">' + planName + discount + '</button>';
      });
      html += '</div>';
      freqContainer.innerHTML = html;
      freqContainer.querySelectorAll('.ecs-selector__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          freqContainer.querySelectorAll('.ecs-selector__pill').forEach(function (p) { p.classList.remove('ecs-selector__pill--active'); });
          pill.classList.add('ecs-selector__pill--active');
          var planId = pill.getAttribute('data-plan-id');
          state.sellingPlanId = planId ? parseInt(planId, 10) : null;
          updatePriceDisplay(); updateConfirmButton();
        });
      });
    }

    function updateConfirmButton() {
      var btn = wrapper.querySelector('.ecs-selector__confirm');
      if (!btn) return;
      var changed = state.variantId !== currentVariantId || state.sellingPlanId !== currentSellingPlanId;
      btn.disabled = !changed; btn.style.opacity = changed ? '1' : '0.5';
    }

    var sizesHTML = '';
    productData.variants.forEach(function (v) {
      var active = v.id === state.variantId ? 'ecs-selector__pill--active' : '';
      sizesHTML += '<button class="ecs-selector__pill ' + active + '" data-variant-id="' + v.id + '">' + v.title + '</button>';
    });

    wrapper.innerHTML =
      '<div class="ecs-selector__inner">' +
        '<p class="ecs-selector__label">Tamaño</p>' +
        '<div class="ecs-selector__pills ecs-selector__sizes">' + sizesHTML + '</div>' +
        '<div class="ecs-selector__frequency"></div>' +
        '<div class="ecs-selector__price-row">' +
          '<span class="ecs-selector__price"></span>' +
          '<button class="ecs-selector__confirm" disabled style="opacity:0.5">Actualizar</button>' +
        '</div>' +
        '<p class="ecs-selector__hint">Mín. 3 pagos · Cambia de aroma con 21 días de aviso</p>' +
      '</div>';

    wrapper.querySelectorAll('.ecs-selector__sizes .ecs-selector__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        wrapper.querySelectorAll('.ecs-selector__sizes .ecs-selector__pill').forEach(function (p) { p.classList.remove('ecs-selector__pill--active'); });
        pill.classList.add('ecs-selector__pill--active');
        state.variantId = parseInt(pill.getAttribute('data-variant-id'), 10);
        state.sellingPlanId = null;
        renderFrequencyPills(); updatePriceDisplay(); updateConfirmButton();
      });
    });

    wrapper.querySelector('.ecs-selector__confirm').addEventListener('click', function () {
      var btn = this; btn.textContent = '...'; btn.disabled = true;
      changeCartItem(lineIndex, state.variantId, state.quantity, state.sellingPlanId)
        .then(function () {
          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = 'Actualizar'; btn.disabled = false; btn.style.opacity = '0.5'; }, 1500);
        })
        .catch(function () { btn.textContent = 'Error — intenta de nuevo'; btn.disabled = false; });
    });

    renderFrequencyPills(); updatePriceDisplay();
    return wrapper;
  }

  function injectSelectors() {
    var domItems = document.querySelectorAll('.rebuy-cart__flyout-item, .rebuy-cart-item');
    if (!domItems.length) return;

    getCart().then(function (cart) {
      if (!cart.items || cart.items.length === 0) return;
      verificarUnidades(cart);

      var domItemsFiltrados = [];
      domItems.forEach(function (el) {
        var tieneContenido = el.querySelector('img, [class*="item-title"], [class*="product-title"], .rebuy-cart__flyout-item-title');
        if (tieneContenido) domItemsFiltrados.push(el);
      });

      cart.items.forEach(function (cartItem, cartIndex) {
        if (cartItem.handle.indexOf('esencia') === -1) return;
        if (cartItem.handle === CONFIG.NOVA_OTP_HANDLE || cartItem.handle === CONFIG.STELLA_OTP_HANDLE) return;

        var itemEl = domItemsFiltrados[cartIndex];
        if (!itemEl) return;
        if (itemEl.querySelector('.ecs-selector')) return;

        var lineIndex = cartIndex + 1;

        getProductData(cartItem.handle).then(function (productData) {
          var tieneVariantes = productData.variants && productData.variants.length > 1;
          var tienePlanes    = productData.selling_plan_groups && productData.selling_plan_groups.length > 0;
          if (!tieneVariantes && !tienePlanes) return;
          var selector = buildSelector(cartItem, productData, lineIndex);
          if (!selector) return;
          var infoEl = itemEl.querySelector('.rebuy-cart__flyout-item-info') || itemEl;
          infoEl.appendChild(selector);
        });
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // POLLING — v15c
  // 500ms + bloqueo inmediato + flag fromPolling para evitar
  // el delay extra de 300ms en el handler rebuy:cart:change
  // ─────────────────────────────────────────────────────────────

  var pollingInterval = null;
  var ultimoCartToken = '';

  function generarFirmaCarrito(cart) {
    return cart.items.map(function (it) {
      return it.handle + ':' + it.quantity;
    }).join('|');
  }

  function iniciarPolling() {
    if (pollingInterval) return;

    pollingInterval = setInterval(function () {
      var cartVisible = document.querySelector('.rebuy-cart__flyout, .rebuy-cart--open');
      if (!cartVisible) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var firma = generarFirmaCarrito(cart);

          if (ultimoCartToken !== '' && firma !== ultimoCartToken) {
            // Bloquear checkout inmediatamente — antes de que el swap termine
            swapEnProceso = false;
            bloquearCheckout(true);
            // Marcar que viene del polling para eliminar el delay del handler
            document.dispatchEvent(new CustomEvent('rebuy:cart:change', {
              detail: { fromPolling: true }
            }));
          }

          ultimoCartToken = firma;
        })
        .catch(function () {});
    }, 500); // 500ms — detecta cambios más rápido que antes (era 800ms)
  }

  function detenerPolling() {
    if (pollingInterval) { clearInterval(pollingInterval); pollingInterval = null; }
    ultimoCartToken = '';
  }

  // ─────────────────────────────────────────────────────────────
  // OBSERVER + EVENTOS + INIT
  // ─────────────────────────────────────────────────────────────

  function watchForCartItems() {
    var timeout = null;
    var observer = new MutationObserver(function (mutations) {
      var relevante = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            var esFlyout = node.classList && (
              node.classList.contains('rebuy-cart__flyout') ||
              node.classList.contains('rebuy-cart__flyout-item') ||
              node.classList.contains('rebuy-cart-item'));
            var contiene = node.querySelector && (
              node.querySelector('.rebuy-cart__flyout-item') ||
              node.querySelector('.rebuy-cart-item'));
            if (esFlyout || contiene) relevante = true;
          }
        });
        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            var era = node.classList && (
              node.classList.contains('rebuy-cart__flyout-item') ||
              node.classList.contains('rebuy-cart__flyout') ||
              node.classList.contains('rebuy-cart-item'));
            var contenia = node.querySelector && (
              node.querySelector('.rebuy-cart__flyout-item') ||
              node.querySelector('.rebuy-cart-item'));
            if (era || contenia) relevante = true;
          }
        });
      });
      if (!relevante) return;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        document.querySelectorAll('.ecs-selector').forEach(function (el) { el.remove(); });
        injectSelectors(); ejecutarSwap(); ocultarCantidadDifusoresEspeciales();
      }, 500);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    interceptarCheckout();
    watchForCartItems();

    document.addEventListener('rebuy:smartcart:open', function () {
      ultimoCartToken = '';
      iniciarPolling();
      setTimeout(function () { injectSelectors(); ejecutarSwap(); ocultarCantidadDifusoresEspeciales(); }, 300);
    });

    document.addEventListener('rebuy:smartcart:close', function () {
      detenerPolling();
    });

    document.addEventListener('rebuy:cart:ready', function () {
      ultimoCartToken = '';
      iniciarPolling();
      setTimeout(function () { injectSelectors(); ejecutarSwap(); ocultarCantidadDifusoresEspeciales(); }, 300);
    });

    // ── v15c: sin delay cuando viene del polling ──────────────
    // Si fromPolling = true → el polling ya esperó 500ms, no agregar más
    // Si fromPolling = false → viene de Rebuy nativo, esperar 300ms
    document.addEventListener('rebuy:cart:change', function (e) {
      var delay = (e && e.detail && e.detail.fromPolling) ? 0 : 300;
      setTimeout(function () {
        swapEnProceso = false;
        document.querySelectorAll('.ecs-selector').forEach(function (el) { el.remove(); });
        injectSelectors(); ejecutarSwap(); ocultarCantidadDifusoresEspeciales();
      }, delay);
    });

    document.addEventListener('rebuy:cart:refresh', function () {
      setTimeout(function () { injectSelectors(); ocultarCantidadDifusoresEspeciales(); }, 500);
    });

    if (document.querySelector('.rebuy-cart__flyout-item, .rebuy-cart-item')) {
      ultimoCartToken = '';
      iniciarPolling();
      setTimeout(function () { injectSelectors(); ejecutarSwap(); ocultarCantidadDifusoresEspeciales(); }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();